import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'done' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || status === 'sending') return;
    setStatus('sending');
    try {
      const body = new URLSearchParams({ form_type: 'newsletter', email });
      const res = await fetch('/api/form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (!res.ok) throw new Error('failed');
      setStatus('done');
      setTimeout(() => {
        setEmail('');
        setStatus('idle');
      }, 4000);
    } catch {
      setStatus('error');
      setTimeout(() => setStatus('idle'), 4000);
    }
  };

  return (
    <footer className="bg-gradient-to-b from-[#0D1117] to-[#000000] border-t border-cyan-500/10 py-20">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="space-y-6">
            <img 
              src="/images/46227a773db6.webp" 
              alt="Space Capsule Living" 
              className="h-10 w-auto"
            />
            <p className="text-sm text-gray-400 leading-relaxed">
              Future living, grounded in reality. Smart modular capsules for luxury glamping, short-stay accommodation, and property projects.
            </p>
            <p className="text-sm text-gray-400 mt-8">
              ABN: 90 634 527 067
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-medium mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/product-range" className="text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Product Range</Link></li>
              <li><Link to="/product-specifications" className="text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Specifications</Link></li>
              <li><Link to="/granny-flats-victoria" className="text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Granny Flats Victoria</Link></li>
              <li><Link to="/glamping-pods-australia" className="text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Glamping Pods</Link></li>
              <li><Link to="/backyard-office-pods-melbourne" className="text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Backyard Offices</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Contact Us</Link></li>
              <li><Link to="/privacy-policy" className="text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-medium mb-6">Contact</h4>
            <ul className="space-y-3">
              <li className="text-sm text-gray-400">218/89 High Street</li>
              <li className="text-sm text-gray-400">Kew VIC 3101, Australia</li>
              <li><a href="tel:+61390086321" className="text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">+61 3 9008 6321</a></li>
              <li><a href="mailto:info@nexapods.com.au" className="text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">info@nexapods.com.au</a></li>
              <li><Link to="/contact" className="text-sm text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer">Contact Us →</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-white font-medium mb-6">Stay Updated</h4>
            <p className="text-sm text-gray-400 mb-4">Subscribe to our newsletter for the latest updates.</p>
            <form id="newsletter-form" onSubmit={handleSubmit} className="space-y-3">
              <input
                type="email"
                name="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                className="w-full px-4 py-2.5 bg-white/5 border border-cyan-500/20 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500/50 transition-all text-sm"
              />
              <button
                type="submit"
                disabled={status === 'sending' || status === 'done'}
                className="w-full px-6 py-2.5 bg-cyan-500 text-black text-sm font-medium rounded-full hover:bg-cyan-400 transition-all hover:shadow-[0_0_20px_rgba(0,217,255,0.5)] disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {status === 'sending' ? 'Subscribing...' : status === 'done' ? 'Subscribed!' : 'Subscribe'}
              </button>
              {status === 'done' && (
                <p className="text-xs text-green-400">Thank you for subscribing!</p>
              )}
              {status === 'error' && (
                <p className="text-xs text-red-400">Something went wrong. Please try again.</p>
              )}
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-cyan-500/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-center md:text-left">
              <p className="text-sm text-gray-500">
                © 2026 Nexa Pods. All rights reserved. · Powered by U Design Studio
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
